//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetOperatorList = () =>
    request({
        url: ApiURL.Query.GetOperatorList,
        method: RequestType.GET,
        //params:params,
    });
const GetOperatorService = () =>
    request({
        url: ApiURL.Query.GetOperatorService,
        method: RequestType.GET,
    });

const GetOperatorListByRoleId = (params: any) =>
    request({
        url: ApiURL.Query.getOperatorListByRoleId + '/' + params + '/operators',
        method: RequestType.GET,
        //params:params,
    });

const GetRolesList = () =>
    request({
        url: ApiURL.Query.GetRolesList,

        method: RequestType.GET,
        //params:params,
    });

const SearchRolesByEndpoint = (path: string) =>
    request({
        url: ApiURL.Query.SearchRolesByEndpoint,
        method: RequestType.GET,
        params: { path },
    });

const GetOperatorRolesList = (data: any) =>
    request({
        url: ApiURL.Query.GetOperatorRolesList + data,

        method: RequestType.GET,
        //params:params,
    });

const GetOperatorFindByUserName = (params: any) =>
    request({
        url: ApiURL.Query.GetOperatorFindByUserName,

        method: RequestType.GET,
        params: params,
    });
const GetRoleAuthorizationList = (data: any) =>
    request({
        url: ApiURL.Query.GetRolesAuthorizationList + '/' + data + '/authorization/list',
        method: RequestType.GET,
        //params:params,
    });
const GetStaffs = () =>
    request({
        url: ApiURL.Query.GetStaffs,

        method: RequestType.GET,
        //params:params,
    });

const OperatorQuery = {
    GetOperatorList,
    GetOperatorRolesList,
    GetOperatorFindByUserName,
    GetOperatorListByRoleId,
    GetRolesList,
    SearchRolesByEndpoint,
    GetRoleAuthorizationList,
    GetOperatorService,
    GetStaffs,
};

export default OperatorQuery;
